// Expandable physician worklist sub-row for Temporarily Unfit crew
import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { PIPELINE_STAGES } from '../../constants/peme-stages';

const WorklistRow = ({ crew }) => {
  const stageHistory = crew.stageHistory || [];

  const getStageStatus = (stage) => {
    const entry = stageHistory.find((h) => h.stage === stage);
    return entry ? entry.status : 'pending';
  };

  const pendingCount = PIPELINE_STAGES.filter(
    (stage) => getStageStatus(stage) !== 'done'
  ).length;

  return (
    <tr className="tw-bg-slate-50/70">
      <td colSpan={6} className="tw-px-6 tw-py-4">
        {/* Header */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
          <span className="tw-text-sm tw-font-semibold tw-text-gray-700">
            Physician Worklist
          </span>
          {pendingCount > 0 && (
            <span className="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-amber-100 tw-text-amber-700">
              {pendingCount} pending
            </span>
          )}
        </div>

        {/* Stage checklist */}
        <div className="tw-flex tw-flex-col tw-gap-1.5">
          {PIPELINE_STAGES.map((stage) => {
            const isDone = getStageStatus(stage) === 'done';
            return (
              <div
                key={stage}
                className="tw-flex tw-items-center tw-justify-between tw-max-w-lg"
              >
                <div className="tw-flex tw-items-center tw-gap-2">
                  {isDone ? (
                    <CheckCircle2 className="tw-w-4 tw-h-4 tw-text-emerald-500 tw-flex-shrink-0" />
                  ) : (
                    <Circle className="tw-w-4 tw-h-4 tw-text-amber-400 tw-flex-shrink-0" />
                  )}
                  <span
                    className={[
                      'tw-text-sm',
                      isDone ? 'tw-text-gray-600' : 'tw-text-gray-700 tw-font-medium',
                    ].join(' ')}
                  >
                    {stage}
                  </span>
                </div>
                <span
                  className={[
                    'tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wide',
                    isDone
                      ? 'tw-bg-emerald-50 tw-text-emerald-600'
                      : 'tw-bg-amber-50 tw-text-amber-600',
                  ].join(' ')}
                >
                  {isDone ? 'Done' : 'Pending'}
                </span>
              </div>
            );
          })}
        </div>
      </td>
    </tr>
  );
};

export default WorklistRow;
